import {
  BookText,
  CirclePlus,
  KeySquare,
  Logs,
  FileBarChart,
} from "lucide-react";
import { SidebarLink } from "./sidebarLink";
import { DOCS_HELP_CENTER_HREF } from "../../lib/supportLinks";
import { Grid2x2CheckIcon } from "lucide-react";
import { useSoc1ExtractionWorkpaperEnabled } from "../../hooks/useSoc1ExtractionWorkpaperEnabled";

export const ExtractionSidebar = ({
  isCollapsed,
}: {
  isCollapsed: boolean;
}) => {
  const reportExtractionsEnabled = useSoc1ExtractionWorkpaperEnabled();

  return (
    <>
      <SidebarLink
        path="/dashboard/extraction/new"
        title="New Extraction"
        icon={<CirclePlus size={20} />}
        isCollapsed={isCollapsed}
      />
      <SidebarLink
        path="/dashboard/templates"
        title="Templates"
        icon={<Logs size={20} />}
        isCollapsed={isCollapsed}
      />
      <SidebarLink
        path="/dashboard/extraction/extractions"
        title="Extractions"
        icon={<Grid2x2CheckIcon size={20} />}
        isCollapsed={isCollapsed}
      />
      {reportExtractionsEnabled && (
        <SidebarLink
          path="/dashboard/report-extraction/jobs"
          title="Reports"
          icon={<FileBarChart size={20} />}
          isCollapsed={isCollapsed}
        />
      )}
      <SidebarLink
        path="/dashboard/apiKeys"
        title="API Keys"
        icon={<KeySquare size={20} />}
        isCollapsed={isCollapsed}
      />
      <SidebarLink
        href={DOCS_HELP_CENTER_HREF}
        title="Docs"
        icon={<BookText size={20} />}
        external
        isCollapsed={isCollapsed}
      />
    </>
  );
};
